import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const promptOptimizeAction = createAsyncThunk("improvePrompt",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.optimizePrompt,arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const promptOptimizeSlice = createSlice({
    name: "improvePrompt",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false,
    },
    reducers: {
        promptOptimizeReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [promptOptimizeAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [promptOptimizeAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [promptOptimizeAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { promptOptimizeReset } = promptOptimizeSlice.actions;
export default promptOptimizeSlice.reducer;


